import { motion } from 'framer-motion'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { useChurchColors } from '@/hooks/useChurchColors'

interface Tab {
  id: string
  label: string
  count?: number
}

interface CustomTabsProps {
  tabs: Tab[]
  activeTab: string
  onTabClick: (tabId: string) => void
  className?: string
}

export function CustomTabs({ tabs, activeTab, onTabClick, className }: CustomTabsProps) {
  const { primaryColor, secondaryColor } = useChurchColors()

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
      className={`flex justify-center ${className}`}
    >
      <div className="flex items-center gap-2 rounded-full bg-muted p-1">
        {tabs.map((tab) => (
          <Button
            key={tab.id}
            variant={activeTab === tab.id ? 'secondary' : 'ghost'}
            size="sm"
            onClick={() => onTabClick(tab.id)}
            className="px-4 py-2 justify-center rounded-full whitespace-nowrap"
            style={
              activeTab === tab.id
                ? {
                    backgroundImage: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}b3)`,
                    color: 'white',
                    borderColor: primaryColor,
                  }
                : {}
            }
          >
            {tab.label}
            {tab.count !== undefined && (
              <Badge 
                variant="tab" 
                className="ml-2"
                style={{
                  backgroundColor: `${secondaryColor}20`,
                  color: secondaryColor,
                  borderColor: `${secondaryColor}40`
                }}
              >
                {tab.count}
              </Badge>
            )}
          </Button>
        ))}
      </div>
    </motion.div>
  )
}